module.exports = __webpack_public_path__ + "img/bg_function02_2_t.92d21ae3.png";